export default __webpack_public_path__ + "static/media/modulePregnancy.7df88b0e.mp4";